import { Menu, MenuItem, Tab, Tabs, styled } from '@mui/material';
import { useState, MouseEvent } from 'react';
import {
  SvgArrowDown1Regular,
  TextV2,
} from '@insights-ltd/design-library/components';
import { getTheme, spacingSizeMap } from '@insights-ltd/design-library/themes';

const StyledDiv = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: '6px',
});

type ActionItem = {
  text: string;
  value: string;
  hidden?: boolean;
};

type ActionDropdownProps = {
  actionItems: ActionItem[];
  onSelect: (value: string) => void;
  actionText: string;
};
export const ActionDropdown = ({
  actionItems,
  onSelect,
  actionText,
}: ActionDropdownProps) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const {
    brandColours: { darkBlue },
    grey: { 700: darkGrey },
  } = getTheme();
  const open = Boolean(anchorEl);
  const handleClick = (event: MouseEvent<any>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleOnSelect = (value: string) => {
    onSelect(value);
    handleClose();
  };

  return (
    <>
      <Tabs value={false} sx={{ minHeight: 0 }}>
        <Tab
          sx={() => ({
            minWidth: '4.5rem',
            margin: `0`,
            padding: '8px 16px 20px',
            opacity: '1',
          })}
          value={-1}
          label={
            <StyledDiv>
              <TextV2 color="primary" variant="bodyBold">
                {actionText}
              </TextV2>
              &nbsp;
              <SvgArrowDown1Regular
                stroke={open ? darkGrey : darkBlue}
                height="8"
                width="11"
                fill="none"
                strokeWidth={4}
                style={{ transform: open ? 'rotate(180deg)' : 'rotate(0)' }}
              />
            </StyledDiv>
          }
          onClick={handleClick}
        />
      </Tabs>
      <Menu
        sx={{
          '.MuiMenu-paper  > ul': {
            paddingTop: '0 !important',
            paddingBottom: '0 !important',
          },
        }}
        elevation={1}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        {actionItems.map(({ text, value, hidden }) => (
          <MenuItem
            sx={(theme) => ({
              color: theme.palette.primary.main,
              fontWeight: theme.typography.fontWeightBold,
              background: theme.palette.common.white,
              padding: `10px ${theme.spacing(spacingSizeMap.S)}`,
              width: '260px',
              display: hidden ? 'none' : 'block',
              whiteSpace: 'break-spaces',
            })}
            key={text}
            onClick={() => {
              handleOnSelect(value);
            }}
          >
            {text}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
